import AdminLayout from '../components/AdminLayout'
import StatsCards from './components/StatsCards'
import MembershipChart from './components/MembershipChart'
import GenderChart from './components/GenderChart'
import RecentMembers from './components/RecentMembers'

export default function AdminOverview() {
  return (
    <AdminLayout>
      <div className="mb-6 lg:mb-8">
        <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
          Overview
        </h1>
        <p className="text-gray-500 text-sm">
          Mighty Mufulira Wanderers · Season 2025/26
        </p>
      </div>
      <StatsCards />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 mt-4 lg:mt-6">
        <div className="lg:col-span-2">
          <MembershipChart />
        </div>
        <div>
          <GenderChart />
        </div>
      </div>
      <div className="mt-4 lg:mt-6">
        <RecentMembers />
      </div>
    </AdminLayout>
  )
}